import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIcon, MatIconModule } from '@angular/material/icon';
import { MAT_SNACK_BAR_DATA, MatSnackBarModule, MatSnackBarRef } from '@angular/material/snack-bar';

export interface CustomSnackBarData {
  icon?: string;         // Material icon name
  title: string;
  message?: string;
  color?: string;        // e.g. '#4CAF50'
  duration?: number;     // ms
}

@Component({
  selector: 'app-common-snackbar',
  standalone: true,
  imports: [MatIcon,MatIconModule,CommonModule,
    MatSnackBarModule,
    MatButtonModule],
  templateUrl: './common-snackbar.component.html',
  styleUrl: './common-snackbar.component.scss'
})
export class CommonSnackbarComponent {
  constructor(@Inject(MAT_SNACK_BAR_DATA) public data: CustomSnackBarData,
public snackBarRef: MatSnackBarRef<CommonSnackbarComponent>) {}

  close() {
    this.snackBarRef.dismiss();
  }

}
